import { redirect } from '@tanstack/react-router'

import { isSuccess } from '@orus.eu/result'

import { buildLoginHref } from './build-login-href.ts'
import { recordLoginBounce, resetLoginBounce } from './detect-login-redirect-loop.ts'
import type { SessionAccess } from './session-access.ts'

export async function requireCustomerSession(context: { session: SessionAccess }): Promise<void> {
  const sessionResult = await context.session.getSessionResult()

  if (!isSuccess(sessionResult)) return

  const session = sessionResult.output
  if (!session.user || session.permissions.type !== 'client') {
    const loginHref = buildLoginHref()
    recordLoginBounce(loginHref)
    throw redirect({ href: loginHref })
  }

  resetLoginBounce()
}
